import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";

class Gale extends WebsiteBehaviors {
	identifier() {
		return "Gale";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "go.gale.com";
	}

	styles() {
		// language=CSS
		return `
			.highlighterMenu {
				display: none !important;
			}
		`;
	}

	async generateStructuredCitation() {
		// Use their citation API
		const citationUrl = new URL("https://go.gale.com/ps/citationtools/rest/cite/getcitations");

		// Get document data to send to their endpoint
		const input = document.querySelector("form.citationToolsRisDownload input[name=\"documentData\"]");
		if (!input)
			return null;

		const data = input.getAttribute("value");

		const response = await fetch(citationUrl, {
			headers: {
				"content-type": "application/json; charset=UTF-8"
			},
			method: "POST",
			body:   `[${data!.toString()}]`
		});
		if (response.status !== 200)
			return null;

		// Extract RIS only
		const responseText = await response.json();
		const ris = responseText["RIS"][0];

		return Citation.fromRIS(ris);
	}
}

export default Gale;
